// Prev/next context for the consultation detail page: the ordered ids of the scribe list a
// consultation was opened from, kept in sessionStorage so it survives a reload.
const CONSULTATION_NAVIGATION_KEY = 'consultationNavigation';

/** Store `consultationIds` as the list to page through, positioned at `consultationId`. */
export function saveConsultationNavigation(consultationIds, consultationId) {
  const currentIndex = consultationIds.indexOf(consultationId);
  if (consultationIds.length === 0 || currentIndex === -1) return;
  try {
    sessionStorage.setItem(CONSULTATION_NAVIGATION_KEY, JSON.stringify({
      consultationIds,
      currentIndex
    }));
  } catch (error) {
    console.warn('Failed to save navigation context to session storage:', error);
  }
}

/**
 * The stored list positioned at `consultationId` (the new position is written back), or null
 * when there is no stored list or `consultationId` is not in it.
 * @returns {{ consultationIds: string[], currentIndex: number }|null}
 */
export function readConsultationNavigation(consultationId) {
  try {
    const stored = sessionStorage.getItem(CONSULTATION_NAVIGATION_KEY);
    if (!stored) return null;
    const context = JSON.parse(stored);
    const currentIndex = context.consultationIds.indexOf(consultationId);
    if (currentIndex === -1) return null;
    const positioned = { ...context, currentIndex };
    sessionStorage.setItem(CONSULTATION_NAVIGATION_KEY, JSON.stringify(positioned));
    return positioned;
  } catch (error) {
    console.warn('Failed to read navigation context from session storage:', error);
    return null;
  }
}

export function clearConsultationNavigation() {
  try {
    sessionStorage.removeItem(CONSULTATION_NAVIGATION_KEY);
  } catch (error) {
    console.error('Error clearing session storage:', error);
  }
}
